import { validateInput } from '../utilities/FormValidator';
import Floatl from 'floatl';
import BaseComponent from '../abstracts/BaseComponent';

export default class MaterialInputComponent extends BaseComponent {
  constructor(element) {
    super(element);
    this.floatl = new Floatl(this.$el);
    const zipCode = this.$el.querySelector('[name*="postalCode"]');
    if (zipCode) {
      this.validateOnKeyupZipCode(zipCode);
    }
  }

  validateOnKeyupZipCode(input) {
    const validate = validateInput();
    this.$on('keyup.zipCode', (e) => {
      validate(input);
    }, input);
  }
}
